import LanguageTypes from './language.types';

export const setLanguages = language => ({
    type: LanguageTypes.ADD_LANGUAGE,
    payload: language
});

export default setLanguages;